<div class="p-grid mu-alert mu-alert__{{ styles }}" *ngIf="showAlert">
  <em class="fas fa-exclamation-triangle" aria-hidden="true"></em>
  <span>{{ message | translate }}</span>
  <em class="close fa fa-times-circle-o" aria-hidden="true" (click)="closeAlert()"></em>
</div>
